export const RESULT_REQUEST = 'RESULT_REQUEST'
export const RESULT_ERROR = 'RESULT_ERROR'
export const RESULT_ADD = 'RESULT_ADD'
export const RESULT_ADD_SUCCESS = 'RESULT_ADD_SUCCESS'
export const RESULT_FIND = 'RESULT_FIND'
export const RESULT_FIND_SUCCESS = 'RESULT_FIND_SUCCESS'
export const RESULT_FIND_ERROR = 'RESULT_FIND_ERROR'
export const RESULT_RESET_STATE = 'RESULT_RESET_STATE'
